import React, { useState, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const assignmentContext = createContext();

export const AssignmentProvider = ({ children }) => {
  const [noOfAssignments, setNoOfAssignments] = useState(0);
  const [selectedCourseId, setSelectedCourseId] = useState('');
  const [selectedFolderId, setSelectedFolderId] = useState('');
  const [selectedStatusId, setSelectedStatusId] = useState([]);
  const [selectedAssignedViaId, setSelectedAssignedViaId] = useState([]);
  const [selectedKeyWord, setSelectedKeyWord] = useState('');
  const [search, setSearch] = useState(false);
  const [assignedData, setAssignedData] = useState([]);
  const [assignmentId, setAssignmentId] = useState('');
  const [assignmentOptions, setAssignmentOptions] = useState('');
  const [assignmentIdSend, setAssignmentIdSend] = useState([]);
  const [assignmentName, setAssignmentName] = useState('');
  const [assignmentCourseId, setAssignmentCourseId] = useState('');
  const [classes, setClasses] = useState([]);
  const [assignmentAssignedViaDetails, setAssignmentAssignedViaDetails] = useState({
    id: null,
    name: null
  });
  //assign modal variable
  const [assignmentMode, setAssignmentMode] = useState('open');
  const [masteryValue, setMasteryValue] = useState(80);
  const [availabilityOption, setAvailabilityOption] = useState('Always');
  const [studentFileUpload, setStudentFileUpload] = useState(false);
  const [includeCR, setIncludeCR] = useState(false);
  const [retakeHour, setRetakeHour] = useState(0);
  const [retakeMinute, setRetakeMinute] = useState(0);
  const [retakeMode, setRetakeMode] = useState('quiz');
  const [retakeEndDate, setRetakeEndDate] = useState('');
  const [retakeQuestion, setRetakeQuestion] = useState(1);
  const [retakeStartDate, setRetakeStartDate] = useState('');
  const [retakesEnabled, setRetakesEnabled] = useState(false);
  const [retakeLimitValue, setRetakeLimitValue] = useState(1);
  const [retakeAvailabilty, setRetakeAvailabilty] = useState('always');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [timedHour, setTimedHour] = useState(0);
  const [timedMinute, setTimedMinute] = useState(0);
  const [randomized, setRandomized] = useState(false);
  const [textToSpeech, setTextToSpeech] = useState(false);
  const [autoLockQuestions, setAutoLockQuestions] = useState(false);
  const [showGrade, setShowGrade] = useState(false);
  const [allowLangChange, setAllowLangChange] = useState(false);
  const [allowAnswerChange, setAllowAnswerChange] = useState(false);
  const [isTimed, setIsTimed] = useState(false);
  const [timeOnTaskSeconds, setTimeOnTaskSeconds] = useState(60);
  const [timeOnTaskEnabled, setTimeOnTaskEnabled] = useState(false);
  const [lockBrowser, setLockBrowser] = useState(false);
  const [photoMathBlock, setPhotoMathBlock] = useState(false);
  const [calculatorEnabled, setCalculatorEnabled] = useState(1);
  const [calculatorType, setCalculatorType] = useState(0);
  const [useProtractor, setUseProtractor] = useState(1);
  const [scoreRetries, setScoreRetries] = useState(0);
  const [autoStartCRUponGrading, setAutoStartCRUponGrading] = useState(false);
  const [assignedDataStatus, setAssignedDataStatus] = useState(new Date().getSeconds());
  const [crAnswerToolType, setCrAnswerToolType] = useState(1);
  const [assignedStatus, setAssignedStatus] = useState(0);
  const [assignedName, setAssignedName] = useState([]);
  const [assignedCourseName, setAssignedCourseName] = useState([]);
  const [allAssignedVia, setAllAssignedVia] = useState([]);
  const [saveAs, setSaveAs] = useState(false);
  const [neverShow, setNeverShow] = useState(true);
  const [folderUpdateStatus, setFolderUpdateStatus] = useState(false);
  const [isAssignmentsAvailable, setIsAssignmentsAvailable] = useState(true);
  const [noOfAssignedStudents, setNoOfAssignedStudents] = useState(0);
  const [assignedCount, setAssignedCount] = useState(0);
  const [initialFromValue, setInitialFromValue] = useState('');
  const [initialToValue, setInitialToValue] = useState('');
  const [useRuler, setUseRuler] = useState(1);
  const [assignedViaUpdate, setAssignedViaUpdate] = useState(false);
  const [collaboratorUpdate, setCollaboratorUpdate] = useState('');
  const [mcChoices, setMcChoices] = useState([
    {
      id: 0,
      name: '1234'
    },
    {
      id: 1,
      name: 'ABCD'
    },
    {
      id: 2,
      name: 'abcd'
    }
  ]);
  const [hasPendingChanges, setHasPendingChanges] = useState(false);

  return (
    <assignmentContext.Provider
      value={{
        allAssignedVia,
        setAllAssignedVia,
        setSelectedCourseId,
        selectedCourseId,
        setSelectedFolderId,
        selectedFolderId,
        setSelectedStatusId,
        selectedStatusId,
        setSelectedAssignedViaId,
        selectedAssignedViaId,
        setSelectedKeyWord,
        selectedKeyWord,
        noOfAssignments,
        setNoOfAssignments,
        search,
        setSearch,
        setAssignmentId,
        assignmentId,
        assignedData,
        setAssignedData,
        assignmentName,
        setAssignmentName,
        classes,
        setClasses,
        assignmentAssignedViaDetails,
        setAssignmentAssignedViaDetails,
        assignedStatus,
        setAssignedStatus,
        //assign modal data
        assignmentMode,
        setAssignmentMode,
        retakeLimitValue,
        setRetakeLimitValue,
        retakeAvailabilty,
        setRetakeAvailabilty,
        retakeQuestion,
        setRetakeQuestion,
        retakeStartDate,
        setRetakeStartDate,
        retakeEndDate,
        setRetakeEndDate,
        retakeHour,
        setRetakeHour,
        retakeMinute,
        setRetakeMinute,
        retakesEnabled,
        setRetakesEnabled,
        retakeMode,
        setRetakeMode,
        masteryValue,
        setMasteryValue,
        availabilityOption,
        setAvailabilityOption,
        studentFileUpload,
        setStudentFileUpload,
        includeCR,
        setIncludeCR,
        crAnswerToolType,
        setCrAnswerToolType,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        isTimed,
        setIsTimed,
        timedMinute,
        setTimedMinute,
        timedHour,
        setTimedHour,
        randomized,
        setRandomized,
        textToSpeech,
        setTextToSpeech,
        autoLockQuestions,
        setAutoLockQuestions,
        showGrade,
        setShowGrade,
        allowLangChange,
        setAllowLangChange,
        allowAnswerChange,
        setAllowAnswerChange,
        timeOnTaskEnabled,
        setTimeOnTaskEnabled,
        timeOnTaskSeconds,
        setTimeOnTaskSeconds,
        lockBrowser,
        setLockBrowser,
        autoStartCRUponGrading,
        setAutoStartCRUponGrading,
        photoMathBlock,
        setPhotoMathBlock,
        calculatorEnabled,
        setCalculatorEnabled,
        calculatorType,
        setCalculatorType,
        useProtractor,
        setUseProtractor,
        useRuler,
        setUseRuler,
        scoreRetries,
        setScoreRetries,
        assignedDataStatus,
        setAssignedDataStatus,
        assignedName,
        setAssignedName,
        assignedCourseName,
        setAssignedCourseName,
        //publish assignment
        saveAs,
        setSaveAs,
        neverShow,
        setNeverShow,
        folderUpdateStatus,
        setFolderUpdateStatus,
        isAssignmentsAvailable,
        setIsAssignmentsAvailable,
        noOfAssignedStudents,
        setNoOfAssignedStudents,
        assignedCount,
        setAssignedCount,
        assignedViaUpdate,
        setAssignedViaUpdate,
        initialFromValue,
        setInitialFromValue,
        initialToValue,
        setInitialToValue,
        assignmentIdSend,
        setAssignmentIdSend,
        collaboratorUpdate,
        setCollaboratorUpdate,
        mcChoices,
        setMcChoices,
        assignmentCourseId,
        setAssignmentCourseId,
        hasPendingChanges, 
        setHasPendingChanges,
        assignmentOptions,
        setAssignmentOptions
      }}>
      {children}
    </assignmentContext.Provider>
  );
};

AssignmentProvider.propTypes = {
  children: PropTypes.node
};

export const useAssignmentContext = () => useContext(assignmentContext);
